import React, { useState, useEffect } from "react";
import config from "../../config/config";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const EmailVerificationPage = () => {
  const [verificationStatus, setVerificationStatus] = useState(null);
  const [countdown, setCountdown] = useState(10);
  const baseURL = config.API_BASE_URL;
  const navigate = useNavigate();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("token");

    if (token) {
      axios
        .get(`${baseURL}/v1/client-users/client-verify-email?token=${token}`)
        .then((response) => {
          console.log("Response:", response);
          setVerificationStatus("success");
        })
        .catch((error) => {
          setVerificationStatus("error");
        });
    }
  }, []);

  useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);

      return () => clearTimeout(timer);
    } else if (countdown === 0) {
      navigate("/login");
    }
  }, [verificationStatus, countdown, navigate]);

  return (
    <div className="email-verificaion-container">
      {verificationStatus === "success" ? (
        <>
          Email verification successful!
          <div className="email-verificaion-countdown">
            You can click Log In or be redirected in {countdown} seconds...
          </div>
          <div
            className="email-verificaion-link"
            onClick={() => navigate("/login")}
          >
            Login now
          </div>
        </>
      ) : verificationStatus === "error" ? (
        <>
          There was an error verifying your email. Please try again.
          <div className="email-verificaion-countdown">
            Redirecting in {countdown} seconds...
          </div>
        </>
      ) : (
        <>Verifying...</>
      )}
    </div>
  );
};

export default EmailVerificationPage;
